import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { CREATE_INVENTORY_QUOTA, CREATE_INVENTORY_QUOTA_SUCCESS, CREATE_INVENTORY_QUOTA_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* createInventoryQuota({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/v2/admin/inventory-quota`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CREATE_INVENTORY_QUOTA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_INVENTORY_QUOTA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_INVENTORY_QUOTA_ERROR, payload: error });
  }
}

export function* watchCreateInventoryQuota() {
  yield takeEvery(CREATE_INVENTORY_QUOTA, createInventoryQuota);
}

function* createInventoryQuotaSaga() {
  yield all([fork(watchCreateInventoryQuota)]);
}

export default createInventoryQuotaSaga;
